import React, { useEffect, useState } from "react";
import { Star, Send, Link2, MousePointerClick } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { frDate } from "@/lib/deals";

const field = "w-full bg-md-bg border border-md-border rounded-xl px-3.5 py-2.5 text-sm focus:outline-none focus:border-md-secondary";

export default function ReviewsPanel() {
  const { authFetch } = useAuth();
  const [data, setData] = useState({ url: "", items: [] });
  const [url, setUrl] = useState("");
  const [form, setForm] = useState({ name: "", email: "" });
  const [msg, setMsg] = useState("");

  const load = async () => {
    const d = await (await authFetch("/admin/reviews")).json();
    setData(d);
    setUrl(d.url);
  };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const saveUrl = async () => {
    const r = await authFetch("/admin/reviews/settings", { method: "PUT", body: JSON.stringify({ url }) });
    setMsg(r.ok ? "Lien enregistré." : (await r.json()).detail || "Lien invalide.");
  };

  const send = async (e) => {
    e.preventDefault();
    const r = await authFetch("/admin/reviews/request", { method: "POST", body: JSON.stringify(form) });
    if (r.ok) { setForm({ name: "", email: "" }); setMsg("Demande d'avis envoyée."); load(); } else setMsg("Envoi impossible, vérifiez l'email.");
  };

  const clicks = data.items.filter((i) => i.clicked_at).length;

  return (
    <div className="space-y-6" data-testid="reviews-panel">
      <div className="grid md:grid-cols-3 gap-3">
        {[["Demandes envoyées", data.items.length, "reviews-stat-sent"], ["Clics vers Google", clicks, "reviews-stat-clicks"], ["Taux de clic", data.items.length ? `${Math.round((clicks / data.items.length) * 100)} %` : "—", "reviews-stat-rate"]].map(([k, v, id]) => (
          <div key={id} data-testid={id} className="bg-white border border-md-border rounded-2xl p-5">
            <div className="font-serif text-2xl text-md-primary">{v}</div>
            <div className="text-[10px] uppercase tracking-widest text-md-muted mt-1">{k}</div>
          </div>
        ))}
      </div>
      <div className="grid lg:grid-cols-2 gap-4">
        <div className="bg-white border border-md-border rounded-2xl p-6 space-y-3">
          <div className="flex items-center gap-2 font-semibold text-md-primary"><Link2 className="w-4 h-4" /> Lien d'avis Google</div>
          <input data-testid="reviews-url-input" value={url} onChange={(e) => setUrl(e.target.value)} className={field} />
          <div className="flex items-center gap-3">
            <button data-testid="reviews-url-save" onClick={saveUrl} className="bg-md-primary text-white px-5 py-2.5 rounded-full text-sm font-semibold">Enregistrer</button>
            <a href="/avis" target="_blank" rel="noreferrer" className="text-sm text-md-muted underline">Voir la page publique /avis</a>
          </div>
          <p className="text-xs text-md-muted">Un email automatique part 7 jours après le passage d'une affaire en « Signée » (une seule fois par client).</p>
        </div>
        <form onSubmit={send} className="bg-white border border-md-border rounded-2xl p-6 space-y-3" data-testid="reviews-manual-form">
          <div className="flex items-center gap-2 font-semibold text-md-primary"><Star className="w-4 h-4" /> Demander un avis manuellement</div>
          <div className="grid sm:grid-cols-2 gap-3">
            <input data-testid="reviews-name" required placeholder="Nom du client" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={field} />
            <input data-testid="reviews-email" required type="email" placeholder="email@client.fr" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={field} />
          </div>
          <button data-testid="reviews-send" className="inline-flex items-center gap-2 bg-md-secondary hover:bg-md-secondaryHover text-white px-5 py-2.5 rounded-full text-sm font-semibold"><Send className="w-4 h-4" /> Envoyer la demande</button>
        </form>
      </div>
      {msg && <p data-testid="reviews-msg" className="text-sm text-md-primary">{msg}</p>}
      <div className="bg-white border border-md-border rounded-2xl divide-y divide-md-border" data-testid="reviews-list">
        {data.items.length === 0 && <p className="p-6 text-sm text-md-muted text-center">Aucune demande envoyée pour l'instant.</p>}
        {data.items.map((i) => (
          <div key={i.id} className="flex flex-wrap items-center justify-between gap-2 px-5 py-3.5 text-sm">
            <span><strong className="text-md-primary">{i.name}</strong> <span className="text-md-muted">· {i.email} · {i.via === "auto" ? "automatique" : "manuel"} · {frDate(i.sent_at)}</span></span>
            {i.clicked_at ? <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-700"><MousePointerClick className="w-3.5 h-3.5" /> Cliqué le {frDate(i.clicked_at)}</span> : <span className="text-xs text-md-muted">Pas encore cliqué</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
